module.exports = __webpack_public_path__ + "img/326.37ea3378.gif";